import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';


@Component({
    selector: 'app-quoteSearch',
    template: require('./quoteSearch.component.html'),
    styles: [require('./quoteSearch.component.css')]
})
export class QuoteSearchComponent implements OnInit {

    @Input()
    home: any;

    @Input()
    mobile = false;

    @Input()
    reusable = false;

    @HostBinding('style.height')
    @Input()
    inputHeight!: string;

    @Input()
    inputWidth!: string;

    @Output()
    valueChanged: EventEmitter<string> = new EventEmitter<string>();

    value!: string;

    constructor() { }

    ngOnInit() {
    }

    searchQuoteAction(): void {
        this.valueChanged.emit(this.value);
        if (this.reusable) return;
        var val: string = (<HTMLInputElement>document.getElementById("quoteSearchField")).value;
        this.home.searchQuoteFullText(val);
    }
}
